import Vue from 'vue';
import VueRouter from 'vue-router';
import List from '@/views/List/List';
import store from '@/store';
import Detail from '@/views/Detail/Detail';
import Session from '@/views/Session/Session';
import About from '@/views/About/About';
import Login from '@/views/Login';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { public: true }
  },
  {
    path: '/',
    name: 'Home',
    component: List,
    meta: { private: true }
  },
  {
    path: '/presentations/:presentationId',
    name: 'Presentation',
    component: Detail,
    meta: { private: true }
  },
  {
    path: '/sessions/:sessionId',
    name: 'Session',
    component: Session,
    meta: { private: true }
  },
  {
    path: '/about',
    name: 'About',
    component: About
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(async (to, from, next) => {
  // Allow access to public routes (like login)
  if (to.meta.public) {
    next();
    return;
  }

  // Check if user is authenticated
  if (store.state.authentication.isAuthenticated) {
    next();
    return;
  }

  // Try to auto-sign in with existing token
  const isAuthenticated = await store.dispatch('authentication/autoSignIn');

  if (isAuthenticated) {
    next();
  } else {
    // Redirect to login if not authenticated
    next('/login');
  }
});

export default router;
